import axios from "axios";

export const axiosClient = axios.create({
  baseURL: "https://florapoint.su/api.admin/",
  headers: {
    "Content-Type": "application/json",
  },
});

axiosClient.interceptors.request.use((config) => {
  if (config.data instanceof FormData) {
    delete config.headers["Content-Type"];
  }
  return config;
});
